import { render, staticRenderFns } from "./IssueEditTabInformation.vue?vue&type=template&id=9fe13494&"
import script from "./IssueEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./IssueEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./IssueEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports